<template>
  <l-layout :layout="['xs12']">
    <l-data-table
    :headers="header"
    title-text="消息发送配置列表"
    :get-data-func="getSendConfigList"></l-data-table>
    <l-fixed-btn
      @click="addSendConfig"
      icon="$vuetify.icons.add"
    ></l-fixed-btn>
  </l-layout>
</template>

<script>
import LDataTable from '../../../ladmin/components/LDataTable/LDataTable'
export default {
  name: 'sendConfig',
  components: {LDataTable},
  data () {
    return {
      header: [
        {text: '配置名称', value: 'name', align: 'left', sortable: false},
        {text: '创建时间', value: 'creationTime', align: 'left', sortable: false}
      ]
    }
  },
  methods: {
    async getSendConfigList () {
      return {items: [], amount: 0}
    },
    addSendConfig () {
      this.$router.push({name: 'newSendConfig'})
    }
  }
}
</script>

<style scoped>

</style>
